import React from 'react';
import { CardMedia } from '@mui/material';
import defaultImage from '@shared/assets/slides-noImg/no-hotel1.png';

import { sxStyle } from './styles';

const BookingImage = ({ image, title }) => {
  const onMediaFallback = event => (event.target.src = defaultImage);

  return (
    <CardMedia
      component="img"
      image={image || defaultImage}
      title={title}
      onError={onMediaFallback}
      sx={sxStyle.media}
    />
  );
};

export default BookingImage;
